import React from 'react';
import { BellIcon, HomeIcon, IdCardIcon, LayoutGridIcon, SparklesIcon, UserRoundIcon } from 'lucide-react';
import { citizenFirstName, mobileItems } from '../../data/espace';
export function PhoneMockup() {
  return <div aria-hidden="true" className="mx-auto w-[280px] rounded-[2.5rem] border-[10px] border-ville-navy bg-white shadow-2xl shadow-ville-navy/25" data-id="element-1137" data-mp="1s1i4g2lo4u6d">
      <div className="flex h-[560px] flex-col overflow-hidden rounded-[1.8rem]" data-id="element-1138" data-mp="1wx74s85iif3q">
        <div className="flex items-center justify-between px-5 pt-5" data-id="element-1139" data-mp="2kpvzqaldhce8">
          <span className="text-[15px] font-extrabold text-ville-navy" data-id="element-1140" data-mp="2pn5wycf06scm">Bonnyville</span>
          <span className="relative grid h-8 w-8 place-items-center rounded-full bg-slate-100 text-ville-navy" data-id="element-1141" data-mp="2arq4ucxzh6iv">
            <BellIcon className="h-4 w-4" data-id="element-1142" data-mp="2foq7edvmjr58" />
            <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-red-600 ring-2 ring-white" data-id="element-1143" data-mp="2frulc2yw6193" />
          </span>
        </div>

        <div className="px-5 pt-5" data-id="element-1144" data-mp="14b4i8sprlpjp">
          <p className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-1145" data-mp="14c5xzahq707r">Hello {citizenFirstName}</p>
          <div className="mt-3 flex items-center gap-2 rounded-full border border-slate-200 px-3 py-2" data-id="element-1146" data-mp="30o42fevgbdwc">
            <SparklesIcon className="h-4 w-4 text-ville-indigo" data-id="element-1147" data-mp="2vp9kef5b5tda" />
            <span className="text-xs text-slate-400" data-id="element-1148" data-mp="39nhfsimp4mmc">What can I do for you?</span>
          </div>
        </div>

        <div className="mt-5 flex-1 px-5" data-id="element-1149" data-mp="34ma4i9lch5ax">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-1150" data-mp="3jkm3imw6wq59">For you</p>
          <ul className="mt-2.5 space-y-2.5" data-id="element-1151" data-mp="3em106eln5qcl">
            <li className="rounded-2xl border-l-4 border-red-600 bg-slate-50 px-4 py-3" data-id="element-1152" data-mp="3ekzl7z1i8jpl">
              <p className="text-[11px] font-bold uppercase tracking-wider text-red-600" data-id="element-1153" data-mp="3sc4iwvlbb1xa">Urgent</p>
              <p className="text-sm font-bold text-ville-navy" data-id="element-1154" data-mp="3ocnd211z42rl">Boil water advisory</p>
              <p className="text-xs text-slate-500" data-id="element-1155" data-mp="6569rym15yfe">5108 - 46 Street</p>
            </li>
            {mobileItems.map(item => <li key={item.id} className="rounded-2xl border border-slate-200 px-4 py-3" data-id="element-1156" data-mp="187evdujlng5">
                <p className="text-sm font-bold text-ville-navy" data-id="element-1157" data-mp="2uzvz0670uiud">{item.eyebrow}</p>
                <p className="text-xs text-slate-500" data-id="element-1158" data-mp="2yzy1uiohtib8">{item.detail}</p>
              </li>)}
          </ul>
        </div>

        <nav className="mt-4 flex items-end justify-between border-t border-slate-100 px-5 pb-5 pt-3" data-id="element-1159" data-mp="33yhnsj336u3l">
          {[{
          icon: HomeIcon,
          label: 'Home',
          active: true
        }, {
          icon: IdCardIcon,
          label: 'Card',
          active: false
        }].map(tab => <span key={tab.label} className={`flex w-12 flex-col items-center gap-1 text-[10px] font-semibold ${tab.active ? 'text-ville-navy' : 'text-slate-400'}`} data-id="element-1160" data-mp="3induabphvz23">
              <tab.icon className="h-5 w-5" data-id="element-1161" data-mp="3rp51xm3lifyl" />
              {tab.label}
            </span>)}

          <span className="flex w-12 flex-col items-center gap-1 text-[10px] font-bold text-ville-indigo" data-id="element-1162" data-mp="1sc0uj6sux4ls">
            <span className="grid h-11 w-11 -translate-y-2 place-items-center rounded-full bg-ville-indigo text-white shadow-lg shadow-ville-indigo/40" data-id="element-1163" data-mp="1xb3xmlpa10r4">
              <SparklesIcon className="h-5 w-5" data-id="element-1164" data-mp="1pt5t6vlycfur" />
            </span>
            <span className="-mt-1" data-id="element-1165" data-mp="1l0l2i2yceivg">ATNA</span>
          </span>

          {[{
          icon: LayoutGridIcon,
          label: 'Services'
        }, {
          icon: UserRoundIcon,
          label: 'Profile'
        }].map(tab => <span key={tab.label} className="flex w-12 flex-col items-center gap-1 text-[10px] font-semibold text-slate-400" data-id="element-1166" data-mp="1b3zvxd6oczpi">
              <tab.icon className="h-5 w-5" data-id="element-1167" data-mp="28ocqi3t8wkck" />
              {tab.label}
            </span>)}
        </nav>
      </div>
    </div>;
}